<template>
  <div class="index">
    <h1>{{ msg }}</h1>
    <van-button type="default"  to="/login">登录页</van-button>
    <van-button type="default" @click="doPost">doGet</van-button>
  </div>
</template>

<script>
import qs from "qs"


export default {
  name: 'index',
  data () {
    return {
      msg: '首页'
    }
  },
  methods:{
    login: function(){
      this.$router.push({ path:'/login'})
    },
    doPost: function(){
      this.$axios.post('/api/v1/user/code',{phoneNumber: "test"})
           .then(resp => {
              console.log(resp);
           });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue